import React, { useState, useContext, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../../layout"
import SEO from "../../seo"

import { Cover } from "../../anti/cover/cover"
import { AcfCoverMain } from "../../gutenberg/acf-cover-main"
import { Card } from "../../anti/card/card"
import { Container, Section } from "../../anti/grid/grid"
import { Select, InputText } from "../../anti/form/form"
import { Breadcrumb } from "../../anti/breadcrumb/breadcrumb"

import Shape from "../../../assets/img/common/shape.png"

import { LangContext } from "../../../context/LangContext"

import "@glidejs/glide/dist/css/glide.core.min.css"
import "@glidejs/glide/dist/css/glide.theme.min.css"
import { useMediaPredicate } from "react-media-hook"

const ResidencePage = ({ location, pageContext }) => {
  const resizeScreen = useMediaPredicate("(min-width:768px)")
  const { lang, setLang } = useContext(LangContext)
  const [keyword, setKeyword] = useState("")
  // const [loading, setLoading] = useState(false)
  // const [type, setType] = useState("all")
  const [type, setType] = useState("all")
  // const [notfound, setNotFound] = useState([])

  const offset = 0
  const defaultPage = 18
  const limit = 6
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(defaultPage)

  const resetKeyword = () => {
    setKeyword("")
  }

  //prettier-ignore
  const data = useStaticQuery(graphql`
    query {
      imgCover: file(relativePath: { eq: "sample/bg_rectangle-dark-2.jpg" }) {
        id
        name
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wordPress {
        pageBy(uri: "development-landing") {
          title
          slug
          blocks {
            name
            ... on WordPress_AcfDevelopmentLandingBlock {
              name
              attributes {
                className
              }
              developmentLanding {
                name
                landing {
                  title
                  text
                }
                cover {
                  img {
                    sourceUrl
                  }
                  imgMobile{
                    sourceUrl
                  }
                  label
                  title
                }
              }
            }
          }
          translation(language: ID) {
            title
            slug
            blocks {
              name
              ... on WordPress_AcfDevelopmentLandingBlock {
                name
                attributes {
                  className
                }
                developmentLanding {
                  name
                  landing {
                    title
                    text
                  }
                  cover {
                    img {
                      sourceUrl
                    }
                    imgMobile {
                      sourceUrl
                    }
                    label
                    title
                  }
                }
              }
            }
          }
        }
        propertyTypes(where: { slug: "residential" }) {
          edges {
            node {
              id
              children {
                nodes {
                  name
                  projects(first: 100, where: { orderby: { field: MODIFIED, order: DESC } }) {
                    nodes {
                      title
                      slug
                      menuOrder
                      date
                      modified
                      projectTags {
                        nodes {
                          name
                        }
                      }
                      propertyTypes {
                        nodes {
                          translation(language: ID) {
                            seo {
                              title
                              metaDesc
                              twitterTitle
                              twitterDescription
                              twitterImage {
                                sourceUrl
                              }
                              opengraphTitle
                              opengraphDescription
                              opengraphImage {
                                sourceUrl
                              }
                            }
                          }
                          seo {
                            title
                            metaDesc
                            twitterTitle
                            twitterDescription
                            twitterImage {
                              sourceUrl
                            }
                            opengraphTitle
                            opengraphDescription
                            opengraphImage {
                              sourceUrl
                            }
                          }
                          slug
                        }
                      }
                      blocks {
                        name
                        ... on WordPress_AcfCoverMainBlock {
                          attributes {
                            className
                          }
                          coverMain {
                            img {
                              mediaItemUrl
                            }
                            imgOverlay
                            label
                            title
                            text
                            buttons {
                              text
                              link {
                                target
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              translation(language: ID) {
                children {
                    nodes {
                    name
                    projects(first: 100, where: {orderby: {field: MODIFIED, order: DESC}}) {
                      nodes {
                        title
                        slug
                        menuOrder
                        date
                        modified
                        projectTags {
                          nodes {
                            name
                          }
                        }
                        propertyTypes {
                          nodes {
                            slug
                          }
                        }
                        blocks {
                          name
                          ... on WordPress_AcfCoverMainBlock {
                            attributes {
                              className
                            }
                            coverMain {
                              img {
                                mediaItemUrl
                              }
                              imgOverlay
                              label
                              title
                              text
                              buttons {
                                text
                                link {
                                  target
                                  url
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  //Query List Project
  const projectsByTypes =
    data.wordPress?.propertyTypes?.edges?.[0]?.node?.children?.nodes ?? []
  let allProjects = []
  let projectsFeatured = []

  projectsByTypes.map(category => {
    category.projects.nodes.map(item => {
      if (item.menuOrder && item.projectTags.nodes.length === 0) {
        allProjects[item.menuOrder - 1] = { ...item, type: category.name }
      } else if (!item.menuOrder && item.projectTags.nodes.length === 0) {
        allProjects.push({ ...item, type: category.name })
      }

      if (item.projectTags.nodes.length > 0) {
        projectsFeatured.push({ ...item, type: category.name })
      }
    })
  })

  const _allProjectsResidential =
    allProjects && projectsFeatured && allProjects.concat(projectsFeatured)

  const allProjectsResidential = _allProjectsResidential.sort((a, b) => {
    const dateA = new Date(a.modified)
    const dateB = new Date(b.modified)

    const timeA = isNaN(dateA.getTime()) ? 0 : dateA.getTime()
    const timeB = isNaN(dateB.getTime()) ? 0 : dateB.getTime()

    return timeB - timeA
  })

  //Query Content
  const dev = data.wordPress.pageBy.blocks.find(
    x => x.developmentLanding.name === "Residential"
  )

  const devID =
    data.wordPress.pageBy.translation !== null
      ? data.wordPress.pageBy.translation.blocks.find(
          x => x.developmentLanding.name === "Residential"
        )
      : data.wordPress.pageBy.blocks.find(
          x => x.developmentLanding.name === "Residential"
        )

  const devCover =
    lang == "EN"
      ? dev?.developmentLanding?.cover
      : devID?.developmentLanding?.cover
  const devLanding =
    lang == "EN"
      ? dev?.developmentLanding?.landing
      : devID?.developmentLanding?.landing

  const BlankState = <div className="text-center">No result found!</div>

  const searchByKeywordV2 = () => {
    let match = []
    let pagingLoadMore = []

    allProjectsResidential
      .filter(x => x != null)
      .map((item, i) => {
        if (
          item.title.toLowerCase().search(keyword.toLowerCase()) !== -1 &&
          item.type.toLowerCase() === type
        ) {
          const cover = item.blocks.find(x => x.name === "acf/cover-main")
          match.push(
            <div
              className="col-sm-6 col-md-4 sbk-nall"
              key={`${item.title}-${i}`}
            >
              <Card
                variant="overlay"
                title={item.title}
                text={item.type}
                img={
                  (cover &&
                    cover.coverMain.img &&
                    cover.coverMain.img.mediaItemUrl) ||
                  data.imgCover.childImageSharp.fluid
                }
                imgHeight="h-ratio-3-2"
                className="card-property"
                link={
                  item.propertyTypes.nodes[0] !== undefined &&
                  `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                }
              />
            </div>
          )
        }

        if (
          item.title.toLowerCase().search(keyword.toLowerCase()) !== -1 &&
          type === "all"
        ) {
          const cover = item.blocks.find(x => x.name === "acf/cover-main")
          match.push(
            <div
              className="col-sm-6 col-md-4 sbk-all"
              key={`${item.title}-${i}`}
            >
              <Card
                variant="overlay"
                title={item.title}
                text={item.type}
                img={
                  (cover &&
                    cover.coverMain.img &&
                    cover.coverMain.img.mediaItemUrl) ||
                  data.imgCover.childImageSharp.fluid
                }
                imgHeight="h-ratio-3-2"
                className="card-property"
                link={
                  item.propertyTypes.nodes[0] !== undefined &&
                  `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                }
              />
            </div>
          )
        }
      })

    if (type !== "all") {
      allProjectsResidential.filter(
        x =>
          x != null &&
          x.title.toLowerCase().search(keyword.toLowerCase()) !== -1
      ).length > perPage
        ? pagingLoadMore.push(
            <div className="col-md-12 pb-5 pt-5 text-center paging-sbk-nall">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          )
        : ""
    }

    if (type === "all") {
      allProjectsResidential.filter(
        x =>
          x != null &&
          x.title.toLowerCase().search(keyword.toLowerCase()) !== -1
      ).length > perPage
        ? pagingLoadMore.push(
            <div className="col-md-12 pb-5 pt-5 text-center paging-sbk-all">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          )
        : ""
    }

    if (match.length > 0 || pagingLoadMore > 0) {
      return (
        <>
          {match.slice(offset, perPage)}
          {pagingLoadMore}
        </>
      )
    } else {
      return (
        <>
          <div className="col-12">
            <div className="blank-state text-center mb-5">
              <div>
                <h5 className="text-black">
                  {lang == "EN" ? "Not found" : "Tidak ditemukan"}
                </h5>
                <p>
                  {lang == "EN"
                    ? "Try searching with another keyword."
                    : "Coba cari dengan kata kunci lain."}
                </p>
                <img src={Shape} className="img-fluid" />
              </div>
              <h2 className="text-center">
                {lang == "EN" ? "You May Like:" : "Kamu mungkin suka:"}
              </h2>
            </div>
          </div>
          {allProjects.length > 0 &&
            allProjects.map((item, i) => {
              if (i < 3) {
                const cover = item.blocks.find(x => x.name === "acf/cover-main")
                return (
                  <div
                    className="col-sm-6 col-md-4 sbk-yml"
                    key={`${item.title}-${i}`}
                  >
                    <Card
                      variant="overlay"
                      title={item.title}
                      text={item.type}
                      img={
                        (cover &&
                          cover.coverMain.img &&
                          cover.coverMain.img.mediItemUrl) ||
                        data.imgCover.childImageSharp.fluid
                      }
                      imgHeight="h-ratio-3-2"
                      className="card-property"
                      link={
                        item.propertyTypes.nodes[0] !== undefined &&
                        `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                      }
                    />
                  </div>
                )
              }
            })}
        </>
      )
    }
  }

  const searchByFilter = () => {
    let match = []
    let pagingLoadMore = []

    allProjectsResidential
      .filter(x => x != null)
      .map((item, i) => {
        if (item.type.toLowerCase() === type) {
          const cover = item.blocks.find(x => x.name === "acf/cover-main")
          match.push(
            <div
              className="col-sm-6 col-md-4 sbf-nall"
              key={`${item.title}-${i}`}
            >
              <Card
                variant="overlay"
                title={item.title}
                text={item.type}
                img={
                  (cover &&
                    cover.coverMain.img &&
                    cover.coverMain.img.mediaItemUrl) ||
                  data.imgCover.childImageSharp.fluid
                }
                imgHeight="h-ratio-3-2"
                className="card-property"
                link={
                  item.propertyTypes.nodes[0] !== undefined &&
                  `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                }
              />
            </div>
          )
        }

        if (type === "all") {
          const cover = item.blocks.find(x => x.name === "acf/cover-main")
          match.push(
            <div
              className="col-sm-6 col-md-4 sbf-all"
              key={`${item.title}-${i}`}
            >
              <Card
                variant="overlay"
                title={item.title}
                text={item.type}
                img={
                  (cover &&
                    cover.coverMain.img &&
                    cover.coverMain.img.mediaItemUrl) ||
                  data.imgCover.childImageSharp.fluid
                }
                imgHeight="h-ratio-3-2"
                className="card-property"
                link={
                  item.propertyTypes.nodes[0] !== undefined &&
                  `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                }
              />
            </div>
          )
        }
      })

    if (type !== "all") {
      allProjectsResidential.filter(
        x => x != null && x.type.toLowerCase() === type
      ).length > perPage
        ? pagingLoadMore.push(
            <div className="col-md-12 pb-5 pt-5 text-center paging-sbf-nall">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          )
        : ""
    }

    if (type === "all") {
      allProjectsResidential.filter(x => x != null).length > perPage
        ? pagingLoadMore.push(
            <div className="col-md-12 pb-5 pt-5 text-center paging-sbf-all">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          )
        : ""
    }

    if (match.length > 0 || pagingLoadMore > 0) {
      return (
        <>
          {match.slice(offset, perPage)}
          {pagingLoadMore}
        </>
      )
    } else {
      return (
        <>
          <div className="col-12">
            <div className="blank-state text-center mb-5">
              <div>
                <h5 className="text-black">
                  {lang == "EN" ? "Not found" : "Tidak ditemukan"}
                </h5>
                <p>
                  {lang == "EN"
                    ? "Try searching with another keyword."
                    : "Coba cari dengan kata kunci lain."}
                </p>
                <img src={Shape} className="img-fluid" />
              </div>
              <h2 className="text-center">
                {lang == "EN" ? "You May Like:" : "Kamu mungkin suka:"}
              </h2>
            </div>
          </div>
          {allProjects.length > 0 &&
            allProjects.map((item, i) => {
              const cover = item.blocks.find(x => x.name === "acf/cover-main")
              if (i < 3) {
                return (
                  <div
                    className="col-sm-6 col-md-4 ke-10"
                    key={`${item.title}-${i}`}
                  >
                    <Card
                      variant="overlay"
                      title={item.title}
                      text={item.type}
                      img={
                        (cover &&
                          cover.coverMain.img &&
                          cover.coverMain.img.mediItemUrl) ||
                        data.imgCover.childImageSharp.fluid
                      }
                      imgHeight="h-ratio-3-2"
                      className="card-property"
                      link={
                        item.propertyTypes.nodes[0] !== undefined &&
                        `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                      }
                    />
                  </div>
                )
              }
            })}
        </>
      )
    }
  }

  const filterAll = () => {
    let match = []
    let featuredMatch = []

    allProjects.map((item, i) => {
      if (item.type.toLowerCase() === type) {
        if (item.title.toLowerCase().search(keyword.toLowerCase()) !== -1) {
          const cover = item.blocks.find(x => x.name === "acf/cover-main")
          match.push(
            <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
              <Card
                variant="overlay"
                title={item.title}
                text={item.type}
                img={
                  (cover &&
                    cover.coverMain.img &&
                    cover.coverMain.img.mediaItemUrl) ||
                  data.imgCover.childImageSharp.fluid
                }
                imgHeight="h-ratio-3-2"
                className="card-property"
                link={
                  item.propertyTypes.nodes[0] !== undefined &&
                  `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                }
              />
            </div>
          )
        }
      }

      if (type === "all") {
        if (item.title.toLowerCase().search(keyword.toLowerCase()) !== -1) {
          const cover = item.blocks.find(x => x.name === "acf/cover-main")
          match.push(
            <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
              <Card
                variant="overlay"
                title={item.title}
                text={item.type}
                img={
                  (cover &&
                    cover.coverMain.img &&
                    cover.coverMain.img.mediaItemUrl) ||
                  data.imgCover.childImageSharp.fluid
                }
                imgHeight="h-ratio-3-2"
                className="card-property"
                link={
                  item.propertyTypes.nodes[0] !== undefined &&
                  `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                }
              />
            </div>
          )
        }
      }
    })

    projectsFeatured.map((item, i) => {
      if (item.type.toLowerCase() === type) {
        if (item.title.toLowerCase().search(keyword.toLowerCase()) !== -1) {
          const cover = item.blocks.find(x => x.name === "acf/cover-main")
          featuredMatch.push(
            <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
              <Card
                variant="overlay"
                title={item.title}
                text={item.type}
                img={
                  (cover &&
                    cover.coverMain.img &&
                    cover.coverMain.img.mediaItemUrl) ||
                  data.imgCover.childImageSharp.fluid
                }
                imgHeight="h-ratio-3-2"
                className="card-property"
                link={
                  item.propertyTypes.nodes[0] !== undefined &&
                  `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                }
              />
            </div>
          )
        }
      }

      if (type === "all") {
        if (item.title.toLowerCase().search(keyword.toLowerCase()) !== -1) {
          const cover = item.blocks.find(x => x.name === "acf/cover-main")
          featuredMatch.push(
            <div className="col-sm-6 col-md-4" key={`${item.title}-${i}`}>
              <Card
                variant="overlay"
                title={item.title}
                text={item.type}
                img={
                  (cover &&
                    cover.coverMain.img &&
                    cover.coverMain.img.mediaItemUrl) ||
                  data.imgCover.childImageSharp.fluid
                }
                imgHeight="h-ratio-3-2"
                className="card-property"
                link={
                  item.propertyTypes.nodes[0] !== undefined &&
                  `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                }
              />
            </div>
          )
        }
      }
    })

    if (match.length > 0 || featuredMatch.length > 0) {
      return (
        <>
          {featuredMatch}
          {match}
        </>
      )
    } else {
      return (
        <>
          <div className="col-12">
            <div className="blank-state text-center mb-5">
              <div>
                <h5 className="text-black">
                  {lang == "EN" ? "Not found" : "Tidak ditemukan"}
                </h5>
                <p>
                  {lang == "EN"
                    ? "Try searching with another keyword."
                    : "Coba cari dengan kata kunci lain."}
                </p>
                <img src={Shape} className="img-fluid" />
              </div>
              <h2 className="text-center">
                {lang == "EN" ? "You May Like:" : "Kamu mungkin suka:"}
              </h2>
            </div>
          </div>
          {allProjects.length > 0 &&
            allProjects.map((item, i) => {
              const cover = item.blocks.find(x => x.name === "acf/cover-main")
              if (i < 3) {
                return (
                  <Card
                    variant="overlay"
                    title={item.title}
                    text={item.type}
                    img={
                      (cover &&
                        cover.coverMain.img &&
                        cover.coverMain.img.mediaItemUrl) ||
                      data.imgCover.childImageSharp.fluid
                    }
                    imgHeight="h-ratio-3-2"
                    className="card-property"
                    link={
                      item.propertyTypes.nodes[0] !== undefined &&
                      `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                    }
                  />
                )
              }
            })}
        </>
      )
    }
  }

  //Handlechange Select Type
  const handleChange = e => {
    setType(e.value)
  }

  //Handlechange Input Filter
  const getValue = e => {
    setKeyword(e.target.value)
  }

  // Handle Load More
  const handleLoadMore = () => {
    const connectionChecker = window.navigator.onLine
    const nextPage = page + 1
    const nextPerPage = page * limit + defaultPage
    console.log({ nextPage, nextPerPage })
    if (connectionChecker) {
      document.getElementsByClassName("btn-loadmore")[0].innerHTML =
        lang === "EN" ? "Load More" : "Muat lebih banyak"
      setPage(nextPage)
      setPerPage(nextPerPage)
    } else {
      document.getElementsByClassName("btn-loadmore")[0].innerHTML =
        lang == "EN" ? "Failed to Load Data" : "Gagal Memuat Data"
    }
  }

  if (keyword.length === 1) {
    resetKeyword()
  }

  const seo =
    pageContext.langKey === "en"
      ? data.wordPress.propertyTypes?.edges[0].node.children.nodes[0]?.projects
          .nodes[0].propertyTypes.nodes[0].seo ?? []
      : data.wordPress.propertyTypes?.edges[0].node.children.nodes[0]?.projects
          .nodes[0].propertyTypes?.nodes[0].translation?.seo ||
        data.wordPress.propertyTypes?.edges[0].node.children.nodes[0]?.projects
          .nodes[0].propertyTypes.nodes[0]?.seo

  const [imageSource, setImageSource] = useState("")

  useEffect(() => {
    let imageSource = data.imgCover.childImageSharp.fluid
    if (devCover?.img?.sourceUrl) {
      imageSource = devCover?.img?.sourceUrl
      if (devCover.imgMobile.sourceUrl && !resizeScreen) {
        imageSource = devCover.imgMobile.sourceUrl
      }
    }
    setImageSource(imageSource)
  }, [resizeScreen, devCover, data])

  return (
    <Layout>
      <SEO
        title={seo?.title}
        desc={seo?.metaDesc}
        fbImg={
          seo?.opengraphImage?.sourceUrl ||
          devCover?.img?.sourceUrl ||
          data.imgCover.childImageSharp.fluid
        }
        fbTitle={seo?.opengraphTitle}
        fbDesc={seo?.opengraphDescription}
        url={location.href}
        twitterTitle={seo?.twitterTitle}
        twitterDesc={seo?.twitterDescription}
        twitterImg={
          seo?.twitterImage?.sourceUrl ||
          devCover?.img?.sourceUrl ||
          data.imgCover.childImageSharp.fluid
        }
      />

      {devCover && (
        <Cover
          variant="basic"
          theme="dark"
          img={imageSource}
          breadcrumb={<Breadcrumb path={location.pathname} />}
          imgHeight="h-500px h-md-600px"
          imgOverlay="30"
          label={devCover?.label}
          title={devCover?.title}
          className="cover-full cover-main"
        />
      )}

      {/* RESIDENCE Only */}
      <Section className="bg-light">
        <Container className="mw-lg text-md-center">
          <h2 className="h2">{devLanding?.title}</h2>
          <p>{devLanding?.text}</p>
          <div className="mt-4 mt-md-5">
            <div className="row">
              <div className="col-md-5 col-lg-4">
                <div class="form-group mb-md-0">
                  <Select
                    defaultValue
                    callback={handleChange}
                    placeholder={
                      lang == "EN" ? "All Categories" : "Semua Kategori"
                    }
                    options={[
                      {
                        value: "all",
                        label: `${
                          lang == "EN" ? "All Categories" : "Semua Kategori"
                        }`,
                      },
                      { value: "cluster", label: "Cluster" },
                      {
                        value: "apartment",
                        label: `${lang == "EN" ? "Apartment" : "Apartemen"}`,
                      },
                    ]}
                    name="category"
                    className="select-w-icon"
                  />
                </div>
              </div>
              <div className="col-md-7 col-lg-8">
                <div class="form-group mb-0">
                  <div className="form-control-wrapper form-w-icon">
                    <input
                      type="text"
                      id="search"
                      placeholder={
                        lang == "EN"
                          ? "Enter keyword here"
                          : "Masukkan kata kunci pencarian disini"
                      }
                      className="form-control"
                      onChange={getValue}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      <Section className="py-0 bg-light">
        <div className="row row-0">
          {!keyword &&
            type.length < 1 &&
            projectsFeatured.length > 0 &&
            projectsFeatured.slice(offset, perPage).map((item, i) => {
              const cover = item.blocks.find(x => x.name === "acf/cover-main")
              return (
                <div
                  className="col-sm-6 col-md-4 ke-11"
                  key={`featured-${item.title}-${i}`}
                >
                  <Card
                    variant="overlay"
                    title={item.title}
                    text={item.type}
                    img={
                      (cover &&
                        cover.coverMain.img &&
                        cover.coverMain.img.mediaItemUrl) ||
                      data.imgCover.childImageSharp.fluid
                    }
                    imgHeight="h-ratio-3-2"
                    className="card-property"
                    link={
                      item.propertyTypes.nodes[0] !== undefined &&
                      `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                    }
                  />
                </div>
              )
            })}
          {!keyword && type.length < 1 && projectsFeatured.length > perPage ? (
            <div className="col-md-12 pb-5 pt-5 text-center paging-e">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          ) : (
            ""
          )}
          {!keyword &&
            type.length < 1 &&
            allProjects.length > 0 &&
            allProjects.slice(offset, perPage).map((item, i) => {
              const cover = item.blocks.find(x => x.name === "acf/cover-main")
              return (
                <div
                  className="col-sm-6 col-md-4 ke-12"
                  key={`${item.title}-${i}`}
                >
                  <Card
                    variant="overlay"
                    title={item.title}
                    text={item.type}
                    img={
                      (item.blocks.find(x => x.name === "acf/cover-main") &&
                        item.blocks.find(x => x.name === "acf/cover-main")
                          .coverMain.img.mediaItemUrl) ||
                      data.imgCover.childImageSharp.fluid
                    }
                    imgHeight="h-ratio-3-2"
                    className="card-property"
                    link={
                      item.propertyTypes.nodes[0] !== undefined &&
                      `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                    }
                  />
                </div>
              )
            })}
          {!keyword && type.length < 1 && allProjects.length > perPage ? (
            <div className="col-md-12 pb-5 pt-5 text-center paging-f">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          ) : (
            ""
          )}
          {keyword &&
            keyword.length === 0 &&
            type.length < 1 &&
            projectsFeatured.length > 0 &&
            projectsFeatured.slice(offset, perPage).map((item, i) => {
              const cover = item.blocks.find(x => x.name === "acf/cover-main")
              return (
                <div
                  className="col-sm-6 col-md-4 ke-13"
                  key={`featured-${item.title}-${i}`}
                >
                  <Card
                    variant="overlay"
                    title={item.title}
                    text={item.type}
                    img={
                      (cover &&
                        cover.coverMain.img &&
                        cover.coverMain.img.mediaItemUrl) ||
                      data.imgCover.childImageSharp.fluid
                    }
                    imgHeight="h-ratio-3-2"
                    className="card-property"
                    link={
                      item.propertyTypes.nodes[0] !== undefined &&
                      `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                    }
                  />
                </div>
              )
            })}
          {keyword &&
          keyword.length === 0 &&
          type.length < 1 &&
          projectsFeatured.length > perPage ? (
            <div className="col-md-12 pb-5 pt-5 text-center paging-g">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          ) : (
            ""
          )}
          {keyword &&
            keyword.length === 0 &&
            allProjects.length > 0 &&
            allProjects.slice(offset, perPage).map((item, i) => {
              const cover = item.blocks.find(x => x.name === "acf/cover-main")
              return (
                <div
                  className="col-sm-6 col-md-4 ke-14"
                  key={`${item.title}-${i}`}
                >
                  <Card
                    variant="overlay"
                    title={item.title}
                    text={item.type}
                    img={
                      (item.blocks.find(x => x.name === "acf/cover-main") &&
                        item.blocks.find(x => x.name === "acf/cover-main")
                          .coverMain.img.mediaItemUrl) ||
                      data.imgCover.childImageSharp.fluid
                    }
                    imgHeight="h-ratio-3-2"
                    className="card-property"
                    link={
                      item.propertyTypes.nodes[0] !== undefined &&
                      `/development/${item.propertyTypes.nodes[0].slug}/${item.slug}`
                    }
                  />
                </div>
              )
            })}
          {keyword && keyword.length === 0 && allProjects.length > perPage ? (
            <div className="col-md-12 pb-5 pt-5 text-center paging-h">
              <button
                className="btn btn-primary w-100 w-md-25 btn-loadmore"
                onClick={handleLoadMore}
              >
                {lang === "EN" ? "Load More" : "Muat lebih banyak"}
              </button>
            </div>
          ) : (
            ""
          )}
        </div>

        {type.length > 0 && !keyword && (
          <div className="row row-0">{searchByFilter()}</div>
        )}

        {type.length > 0 && keyword && (
          <div className="row row-0">{searchByKeywordV2()}</div>
        )}
      </Section>
    </Layout>
  )
}

export default ResidencePage
